export enum TranslationKeys {
  EXPERIENCE_LEVEL_LESS_THAN_6_MONTHS = 'utils.experienceLevels.lessThan6Months',
  EXPERIENCE_LEVEL_SIX_MONTHS_TO_1_YEAR = 'utils.experienceLevels.sixMonthsTo1Year',
  EXPERIENCE_LEVEL_ONE_TO_2_YEARS = 'utils.experienceLevels.oneTo2Years',
  EXPERIENCE_LEVEL_TWO_TO_3_YEARS = 'utils.experienceLevels.twoTo3Years',
  EXPERIENCE_LEVEL_THREE_TO_4_YEARS = 'utils.experienceLevels.threeTo4Years',
  EXPERIENCE_LEVEL_FOUR_TO_5_YEARS = 'utils.experienceLevels.fourTo5Years',
  EXPERIENCE_LEVEL_FIVE_TO_7_YEARS = 'utils.experienceLevels.fiveTo7Years',
  EXPERIENCE_LEVEL_SEVEN_TO_10_YEARS = 'utils.experienceLevels.sevenTo10Years',
  EXPERIENCE_LEVEL_TEN_TO_15_YEARS = 'utils.experienceLevels.tenTo15Years',
  EXPERIENCE_LEVEL_MORE_THAN_15_YEARS = 'utils.experienceLevels.moreThan15Years',
  EDUCATION_LEVEL_NO_DIPLOMA = 'utils.educationLevels.noDiploma',
  EDUCATION_LEVEL_CAP = 'utils.educationLevels.cap',
  EDUCATION_LEVEL_BEP = 'utils.educationLevels.bep',
  EDUCATION_LEVEL_BAC = 'utils.educationLevels.bac',
  EDUCATION_LEVEL_BAC_1 = 'utils.educationLevels.bac1',
  EDUCATION_LEVEL_BAC_2 = 'utils.educationLevels.bac2',
  EDUCATION_LEVEL_BAC_3 = 'utils.educationLevels.bac3',
  EDUCATION_LEVEL_BAC_4 = 'utils.educationLevels.bac4',
  EDUCATION_LEVEL_BAC_5_MASTER = 'utils.educationLevels.bac5Master',
  EDUCATION_LEVEL_BAC_5_DOCTORATE = 'utils.educationLevels.bac5Doctorate',
  CONTRACT_TYPE_CDI = 'utils.contractTypes.cdi',
  CONTRACT_TYPE_CDD = 'utils.contractTypes.cdd',
  CONTRACT_TYPE_PART_TIME = 'utils.contractTypes.partTime',
  CONTRACT_TYPE_FREELANCE = 'utils.contractTypes.freelance',
  CONTRACT_TYPE_INTERNSHIP = 'utils.contractTypes.internship',
  CONTRACT_TYPE_APPRENTICESHIP = 'utils.contractTypes.apprenticeship',
  CONTRACT_TYPE_GRADUATE_PROGRAM = 'utils.contractTypes.graduateProgram',
  CONTRACT_TYPE_VOLUNTEERING = 'utils.contractTypes.volunteering',
  CONTRACT_TYPE_VDI = 'utils.contractTypes.vdi',
  CONTRACT_TYPE_VIE = 'utils.contractTypes.vie',
  CONTRACT_TYPE_MANDATE = 'utils.contractTypes.mandate',
  CONTRACT_TYPE_TEMPORARY = 'utils.contractTypes.temporary',
  CONTRACT_TYPE_INTERIM = 'utils.contractTypes.interim',
  CONTRACT_TYPE_CONSULTING = 'utils.contractTypes.consulting',
  CONTRACT_TYPE_OTHER = 'utils.contractTypes.other',
}
